export default {
    url: '/reports',
    template: `
        <ui-view></ui-view>
    `,
    data: {
        canAccess: (AuthService, PrivilegeService) => {
            return PrivilegeService.canViewReports();
        }
    },
    abstract: true,
    resolve: {
        classifiers: (ClassifierResource) => ClassifierResource.query({ pageSize: 0 }).$promise,
        employees (TokenService, UserResource, ROLE_CODE_ENUM) {
            return UserResource.query({
                roleCode: ROLE_CODE_ENUM.KEYS.EMPLOYEE,
                'siteIds[]': TokenService.getActiveSiteId(),
                pageSize: 0
            }).$promise;
        }
    },
    controller ($state) {
        this.$state = $state;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/reports/index.js